import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {ConfigService} from '../service/config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class Tracker {
    private storageService: StorageService;
    private configService: ConfigService;
    private httpClient: HttpClient;

    constructor(storageService: StorageService, configService: ConfigService, httpClient: HttpClient) {
        this.storageService = storageService;
        this.configService = configService;
        this.httpClient = httpClient;
    }

    public async trackButtonClick() {
        const partnerId = this.storageService.getObjectFromSession<string>(Keys.PARTNER_ID);
        const partnerTransactionId = this.storageService.getObjectFromSession<string>(Keys.PARTNER_TRANSACTION_ID);
        const trackerPartnerIds = this.configService.getTrackerPartnerIds();
        if (!(partnerId && partnerTransactionId)) {
            return;
        }
        if (!trackerPartnerIds.includes(partnerId)) {
            return;
        }
        let trackerUrl = this.configService.getPartnerTrackerUrlBy(partnerId);
        trackerUrl = `${trackerUrl}&transaction_id=${partnerTransactionId}`;
        const headers = new HttpHeaders().append('content-type', 'text/plain');
        await this.httpClient.post(trackerUrl, {}, {headers: headers}).toPromise();
    }
}
